import { httpV2 } from "../http.js";

const UtilService = {
  // Google Auto Complete
  autoComplete: (input, location, radius = 10000) =>
    httpV2.post("google/autocomplete", { input, location, radius }),
  place: (google_place_id) =>
    httpV2.get(`google/place?google_place_id=${google_place_id}`),
  images: (google_place_id) =>
    httpV2.get(`google/images?google_place_id=${google_place_id}`),
  toggleFlag: (flag, item_id, item_type) =>
    httpV2.post(`/flags/toggle`, { flag, item_id, item_type }),
  //Upload Image to S3
  uploadFile: (fileObject) => httpV2.post("utils/uploads/url", fileObject),
  getPmsFields: () => httpV2.get("utils/pms/fields"),
  shareGuide: (obj) => httpV2.post("utils/share", obj),
  shareMessage: (msg_type, msg_id, contact) =>
    httpV2.post(`utils/share/${msg_id}`, { msg_type, contact }),
  emailDNSCheck: () => httpV2.post(`utils/email_dns_check`, {}),
  dashboardCounts: () => httpV2.get(`utils/counts`),
  dashboardCountsGuestsArrivingToday: () => httpV2.get(`utils/counts/guests-arriving-today`),
  dashboardCountsGuestsCurrentlyStaying: () => httpV2.get(`utils/counts/guests-currently-staying`),
  dashboardCountsGuestsDepartingToday: () => httpV2.get(`utils/counts/guests-departing-today`),
  dashboardCountsGuestsLast30Days: () => httpV2.get(`utils/counts/guests-last-30-days`),
  dashboardCountsHomeGuides: () => httpV2.get(`utils/counts/home-guides`),
  dashboardCountsAreaGuides: () => httpV2.get(`utils/counts/area-guides`),
  dashboardCountsScheduledMessages: () => httpV2.get(`utils/counts/scheduled-messages`),
  dashboardCountsContacts: () => httpV2.get(`utils/counts/contacts`),
  dashboardCountsTextMessagesSent: (startDate, endDate) => httpV2.get(`utils/counts/text-messages-sent?startDate=${startDate}&endDate=${endDate}`),
  dashboardCountsGuestGuideViews: (startDate, endDate) => httpV2.get(`utils/counts/guest-guide-views?startDate=${startDate}&endDate=${endDate}`),
  dashboardCountsAvgGuestRating: (startDate, endDate) => httpV2.get(`utils/counts/avg-guest-rating?startDate=${startDate}&endDate=${endDate}`),
  dashboardCountsSurveyResponses: (startDate, endDate) => httpV2.get(`utils/counts/survey-responses?startDate=${startDate}&endDate=${endDate}`),
  dashboardCountsExtendStaysMessagesSent: (startDate, endDate) => httpV2.get(`utils/counts/extend-stays-messages-sent?startDate=${startDate}&endDate=${endDate}`),
  dashboardCountsLeadsGenerated: (startDate, endDate) => httpV2.get(`utils/counts/leads-generated?startDate=${startDate}&endDate=${endDate}`),
  dashboardCountsOrdersReceived: (startDate, endDate) => httpV2.get(`utils/counts/orders-received?startDate=${startDate}&endDate=${endDate}`),
  dashboardCountsWorkOrdersCreated: (startDate, endDate) => httpV2.get(`utils/counts/work-orders-created?startDate=${startDate}&endDate=${endDate}`),
};

export default UtilService;
